import {Buffer} from 'buffer';

export function withTrafficParameters(url, trafficSource) {
    const params = url.searchParams;
    const append = (name, value) => {if (name?.length > 0) params.append(name, value);};
    append(trafficSource?.costParam, trafficSource?.costPlaceholder);
    // Facebook adds fbclid automatically; Google also uses the braid identifiers.
    if (trafficSource?.externalClickIdParam !== 'fbclid') {
        append(trafficSource?.externalClickIdParam, trafficSource?.externalClickIdPlaceholder);
    }
    if (trafficSource?.externalClickIdParam === 'gclid' && trafficSource?.externalClickIdPlaceholder === '{gclid}') {
        append('wbraid', '{wbraid}');
        append('gbraid', '{gbraid}');
    }
    for (let index = 1; index <= 10; index++) {
        append(trafficSource?.[`custom${index}Param`], trafficSource?.[`custom${index}Placeholder`]);
    }
    return decodeURIComponent(url.toString());
}

export function directTrackingURL({destination, selected, campaign, trafficSource, type}) {
    let destinationURL = destination.url;
    if (type === 'offer') {
        const replacements = {campaignId: campaign.id, trafficSourceId: trafficSource?.id,
            offerId: destination.id, affiliateNetworkId: destination.affiliateNetworkId};
        for (let index = 1; index <= 10; index++) replacements[`custom${index}`] = trafficSource?.[`custom${index}Placeholder`];
        for (const [key, value] of Object.entries(replacements)) destinationURL = destinationURL.replace(`{${key}}`, value);
    }
    const url = new URL(destinationURL);
    const token = {cpid: campaign.publicId, r: selected.rule, p: selected.path, [type === 'offer' ? 'o' : 'l']: selected.index};
    url.searchParams.append('trck', Buffer.from(JSON.stringify(token)).toString('base64'));
    return withTrafficParameters(url, trafficSource);
}

export function campaignDestinations(campaign, type) {
    const destinations = [];
    campaign?.flow?.rules?.forEach((rule, ruleIndex) => {
        rule?.paths?.forEach((path, pathIndex) => {
            if (Boolean(path.directLinking) !== (type === 'offer')) return;
            path[type === 'offer' ? 'offers' : 'landings']?.forEach((item, index) => {
                const id = item[type === 'offer' ? 'offerId' : 'landingId'];
                if (id > 0) destinations.push({id, name: item.name, context: [rule.name, path.name].filter(Boolean).join(' / '),
                    rule: ruleIndex, path: pathIndex, index, key: `${ruleIndex}-${pathIndex}-${index}`});
            });
        });
    });
    return destinations;
}
